export default __webpack_public_path__ + "90e7af0d9fe7dbb64caa2e0059418131.png";